export default __webpack_public_path__ + "static/media/spaced-screenshot.b6de23b3.png";